var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProductConfigurator = function SvgProductConfigurator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 41 40",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.5,
    fill: "#FF4747",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    x: 0.5,
    fill: "url(#product-configurator_svg__a)",
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "M9.363 27.2h3.076v-4.716h2.585c3.345 0 5.291-1.995 5.291-4.9 0-2.89-1.91-4.93-5.213-4.93H9.363zm3.076-7.18v-4.851h2.073c1.776 0 2.635.966 2.635 2.415 0 1.442-.859 2.436-2.62 2.436zM27.009 27.413c2.905 0 4.73-1.704 4.872-4.211h-2.855c-.178 1.164-.945 1.818-1.982 1.818-1.413 0-2.33-1.186-2.33-3.274 0-2.06.924-3.239 2.33-3.239 1.108 0 1.819.732 1.982 1.818h2.855c-.128-2.521-2.038-4.176-4.886-4.176-3.31 0-5.355 2.294-5.355 5.64 0 3.316 2.01 5.624 5.369 5.624"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "product-configurator_svg__a",
    x1: -1.5,
    x2: 45.5,
    y1: -3,
    y2: 46.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.034,
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF002E"
  })))));
};
export default SvgProductConfigurator;